var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 12H14.375V13.25H0.625V12H1.875V1.375C1.875 1.20924 1.94085 1.05027 2.05806 0.933058C2.17527 0.815848 2.33424 0.75 2.5 0.75H12.5C12.6658 0.75 12.8247 0.815848 12.9419 0.933058C13.0592 1.05027 13.125 1.20924 13.125 1.375V12ZM5 6.375V7.625H6.875V6.375H5ZM5 3.875V5.125H6.875V3.875H5ZM5 8.875V10.125H6.875V8.875H5ZM8.125 8.875V10.125H10V8.875H8.125ZM8.125 6.375V7.625H10V6.375H8.125ZM8.125 3.875V5.125H10V3.875H8.125Z",
    fill: "#536378"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompany);
export default __webpack_public_path__ + "static/media/icon_company.8a7baa877c29ebc50eaecc468c8b6f5b.svg";
export { ForwardRef as ReactComponent };